export default {
    titulo: "Equipos",
    nuevo: "Nuevo equipo",
    nroSerie: "Nro. de serie",
    infoAdicional: "Información adicional",
    generar: "Generar",
    textProblema: "Detalla el problema que posee el equipo",
    errorProblema: "Por favor ingresa el problema del equipo",
    textAccesorios: "Detalla los accesorios que posee el equipo",
    precio: "Precio",
    textNotasLegales: "(Figura en notas legales de la orden)",
    nuevoTipo: "Nuevo tipo de equipo",
    editarTipo: "Editar tipo de equipo",
    tituloTipos: "Tipos de equipos",
    eliminarTipo: "Eliminar tipo de equipo",
    pregEliminarTipo: "¿Confirmas que deseas eliminar el tipo de equipo?",
    nuevaMarca: "Nueva marca",
    editarMarca: "Editar marca",
    tituloMarcas: "Marcas",
    eliminarMarca: "Eliminar marca",
    pregEliminarMarca: "¿Confirmas que deseas eliminar la marca?",
    nuevoModelo: "Nuevo modelo",
    editarModelo: "Editar modelo",
    tituloModelos: "Modelos",
    eliminarModelo: "Eliminar modelo",
    pregEliminarModelo: "¿Confirmas que deseas eliminar el modelo?",    
    seleccionarEquipo: "Seleccionar equipo",
    busqueda: "Buscar por descripción, serie, tipo de equipo, marca o modelo",
    mostrarAsociados: "Mostrar solo equipos asociados al cliente",
    incluirInactivos: "Incluir equipos inactivos",
    eliminar: "Eliminar equipo",
    pregEliminar: "¿Confirmas que deseas eliminar el equipo: ",
    editar: "Editar equipo",
    imprimirCodBarras: "Imprimir código de barras",
    imprimirEtiqueta: "Imprimir etiqueta",
    activo: "Activo",
    fechaInstalacion: "Fecha de instalación",
    frecuenciaMant: "Frecuencia de mantenimiento",
    dias: " (en días)",
    comodato: "Comodato",
    propiedad: "Propiedad de la empresa",
    provCompra: "Proveedor de compra",
    provServicio: "Proveedor de servicio técnico",
    fechaCompra: "Fecha de compra",
    vidaUtil: "Vida útil",
    años: " (en años)",
    valorResidual: "Valor residual",
    errorValorResidual: "Debe ser menor que el costo",
    depreciacion: "% Depreciación anual",
    nroInventario: "Nro. de inventario",
    valorNeto: "Valor neto actual",
    facturas: "Facturas de compra",
    historicoUbicacion: "Histórico de ubicación",
    asociarObra: "Obra asociada",
    obraOpcional: "La obra es opcional. Los despachos del equipo se registran bajo esta obra.",
    empresa: "Empresa",
    ultMant: "Último mantenimiento",
    proxMant: "Próximo mantenimiento",
    ubicacion: "Ubicación de equipos",
    textUbicacion: "Explora las sucursales, departamentos y equipos de la cuenta. Al seleccionar una sucursal, se mostrarán los departamentos asociados. Luego, al hacer clic en un departamento, podrás ver los equipos relacionados.Todo esto en un formato de arbol intuitivo y centralizado",
    sinUbicacion: "Sin ubicación",
    buscarModelo: "Buscar por tipo de equipo, marca o modelo",
    msgNotFound: "No se encontró el equipo",
    checklists:{ 
        titulo: "Checklists",
        nuevo: "Nuevo checklist",
        eliminar: "Eliminar checklist",
        pregEliminar: "¿Confirmas que deseas eliminar el checklist?",
        editar: "Editar checklist",
        nuevoItem: "Nuevo item",
        editarItem: "Editar item",
        eliminarItem: "Eliminar item",
        pregEliminarItem: "¿Confirmas que deseas eliminar el item?",
        items: "Items"
    },
    planes: {
        titulo: "Planes de mantenimiento",
        nuevo: "Nuevo plan de mantenimiento",
        eliminar: "Eliminar plan de mantenimiento",
        pregEliminar: "¿Confirmas que deseas eliminar el plan de mantenimiento?",
        editar: "Editar plan de mantenimiento",
    }
}